import type { PropsWithChildren } from 'react';

import type { ActionsProviderProps } from '@/clientState/providers/FlightSummaryActionsProvider';
import FlightSummaryActionsProvider from '@/clientState/providers/FlightSummaryActionsProvider';
import withCheckoutContext from '@/withCheckoutContext';

export default withCheckoutContext<PropsWithChildren<ActionsProviderProps>>(
  FlightSummaryActionsProvider
);
